import React from 'react'

const SubTitle = ({ children, isMobile }) => {
  return (
    <h2 style={{
      fontFamily: 'Red Hat Display',
      fontWeight: 800,
      fontStyle: isMobile ? 'ExtraBold' : 'bold',
      fontSize: isMobile ? '20px' : '36px',
      lineHeight: isMobile ? '140%' : '140%',
      letterSpacing: isMobile ? '-1%' : '-1%',
      textAlign: 'center',
      verticalAlign: 'middle',
      textTransform:'capitalize',
      color: '#1D1D1B',
      margin: 0,
      padding: 0
    }}>
      {children}
    </h2>
  )
}

export default SubTitle
